import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { DURATION } from "../data/globalStyles"

const styles = {
  container: {
    minHeight: "92px",
    width: "311px",
    maxWidth: "311px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 0.25rem 0.5rem 0.25rem",
    border: `2px solid ${colors.orange}`,
    backgroundColor: colors.orange,
    color: colors.white,
    transition: `background-color ${DURATION} ease-in-out, color ${DURATION} ease-in-out`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.white,
      color: colors.black,
    },
    "@media only screen and (max-width: 810px)": {
      flex: "none",
      minHeight: "70px",
      maxWidth: "235px",
      width: "90%",
    },
  },
  restartContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: ".5rem 0",
    border: `2px solid ${colors.orange}`,
    backgroundColor: colors.orange,
    color: colors.white,
    transition: `background-color ${DURATION} ease-in-out, color ${DURATION} ease-in-out`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.white,
      color: colors.black,
    },
    "@media only screen and (max-width: 810px)": {
      flex: "none",
    },
  },
  text: {
    margin: "0 15px",
    fontWeight: "500",
    fontSize: "calc(14px + (18 - 12) * ((100vw - 300px) / (1600 - 300)))",
    textDecoration: "none",
    textAlign: "center",
  },
  restartText: {
    composes: "$text",
    fontSize: "calc(12px + (13 - 12) * ((100vw - 300px) / (1600 - 300)))",
  },
}

const AnswerButton = ({ classes, id, text, onClick }) => {
  const keyHandler = ({ code }) => {
    if (code === "Enter") {
      onClick()
    }
  }

  return (
    <div
      key={`${id}-${text}`}
      className={
        id === "restartQuizButton"
          ? classes.restartContainer
          : classes.container
      }
      onClick={onClick}
      onKeyDown={(e) => keyHandler(e)}
      tabIndex="0">
      <p
        className={
          id === "restartQuizButton" ? classes.restartText : classes.text
        }>
        {text}
      </p>
    </div>
  )
}

export default withStyles(styles)(AnswerButton)
